// console.log("wonderNavInit: Initializer for NavOfWonder.")

function hydrateWonderNavData() {
  // console.log("wonderNavInit: Hydrating data for NavOfWonder...")
  // INITIALIZE with minimal placeholder data for global nav menu...
  let navUserMenu = [];
  let navData = {
    userName: `Default User`,
    userEmail: 'defaul.user@email.example.test'
  }
  let navProfileUrl = '#';
  let navHeaderText = 'Deployed Development/QA Environment';

  if (window.VST) {
    // Uses window.VST.sysUser to get state data from the application session...
    if (window.VST.sysUser && window.VST.sysUser !== null) {
      let sysUser = window.VST.sysUser;

      navData.userName = `${sysUser.first_name} ${sysUser.last_name}`;
      navData.userEmail = sysUser.email;

      navProfileUrl = window.VST.sysUser.profileUrl;
    }

    if (window.VST.userMenu && window.VST.userMenu !== null) {
      navUserMenu = navUserMenu.concat(window.VST.userMenu);
    }

    if (window.VST.navEnv && window.VST.navEnv == "production") {
      navHeaderText = null; // FIXME: Describe "Upload" in Production
    }
  }

  let navLogoutHandler = () => {
    console.log("wonderNavInit: logOutHandler | onLogOut");
    return false;
  };

  navData = {
    ...navData,
    appName: 'Upload',
    headerText: navHeaderText,
    profileUrl: navProfileUrl,
    logOutHandler: navLogoutHandler,
    userMenuItems: navUserMenu
  };

  // console.log("wonderNavInit: Hydrated data for Nav initialization.");
  return navData;
}

function initWonderNav() {
  if(typeof window.VSTWonkaBar === 'object' && window.VSTWonkaBar !== null) {
    // console.log("wonderNavInit: Initializing...");

    let wonderNav = hydrateWonderNavData();

    window.VSTWonkaBar.init({
        elementId: 'globalNavOfWonderContainer',
        appName: wonderNav.appName,
        headerText: wonderNav.headerText,
        name: wonderNav.userName,
        email: wonderNav.userEmail,
        profileUrl: wonderNav.profileUrl,
        onLogOut: wonderNav.logOutHandler,
        userMenuItems: wonderNav.userMenuItems
    });

    window.VST.wonderNav = true;
    // console.log("wonderNavInit: Initialized.");
  }
}

document.addEventListener("DOMContentLoaded", () => {
  // console.log("wonderNavInit: DOM Content Loaded.");
  // `_nav_of_wonder` partial adds header links to source JS & CSS build artifacts
  // page MUST wait for document to finish loading, before able to initialize!
  initWonderNav();
});

document.addEventListener("turbolinks:load", function() {
  // console.log("wonderNavInit: [TurboLinks] Load Event.");
  if (window.VST && !window.VST.wonderNav) {
    // Should NOT need to re-init NavOfWonder for turbolinks:load events but...
    initWonderNav();
  }
});
